import { render, staticRenderFns } from "./EditGamePrize.vue?vue&type=template&id=41a98c46&"
import script from "./EditGamePrize.vue?vue&type=script&lang=js&"
export * from "./EditGamePrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports